import type { ISurveyFormProps } from './SurveyForm';

export async function MountSurveyForm(props: ISurveyFormProps, el: Element) {
	try {
		const module = await import('./SurveyForm');
		module.MountSurveyForm(props, el);
	} catch (error) {
		console.error('Unable to load survey', error);
		const message = document.createElement('p');
		message.setAttribute('role', 'alert');
		message.textContent = 'The survey could not load. ';
		const retry = document.createElement('button');
		retry.type = 'button';
		retry.textContent = 'Retry';
		retry.addEventListener('click', () => {
			el.replaceChildren();
			void MountSurveyForm(props, el);
		});
		message.append(retry);
		el.replaceChildren(message);
	}
}

declare global {
	interface Window {
		MountSurveyForm: typeof MountSurveyForm;
	}
}

window.MountSurveyForm = MountSurveyForm;
